var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconEye = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M10 3c3.95 0 7.44 2.513 8.863 6.252a2.1 2.1 0 0 1 0 1.496C17.44 14.487 13.95 17 10 17s-7.44-2.513-8.863-6.252a2.1 2.1 0 0 1 0-1.496C2.56 5.513 6.05 3 10 3m0 2.055c-3.182 0-5.9 2.05-7 4.945 1.1 2.894 3.818 4.945 7 4.945s5.9-2.05 7-4.945c-1.1-2.894-3.818-4.945-7-4.945m0 1.82c1.656 0 3 1.392 3 3.108s-1.344 3.108-3 3.108S7 11.7 7 9.983c0-1.716 1.344-3.108 3-3.108"
})));
export default SvgIconEye;